import { useNavigate } from 'react-router-dom'
import { PureForbidden } from './PureForbidden'

export const Forbidden = () => {
  const navigate = useNavigate()
  return <PureForbidden onClick={() => navigate('/analytics/overview')} />
}
